import state from '../state'

const getSrciUrl = () => `${process.env.MASTERCARD_SRC_HOST}/access/?origin=${window.location.origin}&traceId=${state.traceId}`

export default getSrciUrl
